import React from 'react';
import PropTypes from 'prop-types';

import useWorkflowGuard from 'hooks/useWorkflowGuard';

const PendingPage = ({ navigate, searchParams }) => {
  useWorkflowGuard(searchParams, navigate);

  return (
    <div className="flex flex-col items-center text-center mb-8">
      <div className="flex flex-col gap-4 text-sm md:text-base text-slate-600 px-0 md:px-[90px]">
        <p>You are pre-approved, but we need more information before we can move forward.</p>
        <p className="leading-[1.6]">
          Please call our
          {' '}
          <span className="font-semibold">Verification Department:</span>
          <br />
          <a href="tel:+18182000238" className="whitespace-nowrap text-blue-500 font-semibold">
            (818) 200-0238
          </a>
        </p>
      </div>

      <div className="flex text-slate-800 flex-col md:flex-row justify-center items-center gap-4 md:gap-8 border rounded-lg p-6 mt-10 max-w-full w-[500px]">
        <div>
          <p className="font-semibold">Monday - Friday</p>
          <span className="text-xs">7:00 AM- 8:00 PM Pacific</span>
        </div>
        <div>
          <p className="font-semibold">Saturday & Sunday</p>
          <span className="text-xs">8:00 AM - 8:00 PM Pacific</span>
        </div>
      </div>
    </div>
  );
};

PendingPage.propTypes = {
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default PendingPage;
